'use strict';

angular.module('amexReconciliationApp')
  .service('CardBillingCyclesRepository', function ($resource, TransactionSearchModel) {
    var self = this;

    var cardmemberSummaryResource = $resource('/api/v1/authenticatedUser/cardmemberSummary', {}, {
      getCardmemberSummary: { method: 'get', isArray: false }
    });

    var cardManagerSummaryResource = $resource('/api/v1/authenticatedUser/cardManagerSummary', {}, {
      getCardManagerSummary: { method: 'get', isArray: false }
    });

    var cardmemberBillingCyclesResource = $resource('/api/v1/cardmemberBillingCycles', {}, {
      getCardmemberBillingCycles: { method: 'get', isArray: true }
    });

    var cardManagerBillingCyclesResource = $resource('/api/v1/cardManagerBillingCycles', {}, {
      getCardManagerBillingCycles: { method: 'get', isArray: true }
    });

    self.getCardmemberSummary = function () {
      return cardmemberSummaryResource.getCardmemberSummary().$promise;
    };

    self.getCardManagerSummary = function () {
      return cardManagerSummaryResource.getCardManagerSummary().$promise;
    };

    self.getBillingCycles = function (cardId, siteNumber) {
      var params = { cardId: cardId, siteNumber: siteNumber };

      if (TransactionSearchModel.isCardManager()) {
        return cardManagerBillingCyclesResource.getCardManagerBillingCycles(params).$promise;
      } else if (TransactionSearchModel.isCardMember()) {
        return cardmemberBillingCyclesResource.getCardmemberBillingCycles(params).$promise;
      }
    };

  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/CardBillingCyclesRepository.js
// module id = 605
// module chunks = 0